import './RSODynamicButton.scss'
export let RSODynamicButton = ({ title, type, className}) => {
  return (
    <div className={`RSODynamicButton ${className}`}>
      <button type={type} className="button-three">{title}</button>
    </div>
  )
}